<div class="container--padding">
  <h2 class="mt-5">{{ "Settings" | translate }}</h2>
  <br />

  <div class="row">
    <div class="col-sm">
      <div class="">
        <h3>{{ "General information" | translate }}</h3>
        <form>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                placeholder="ACME Corp."
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <textarea
                [(ngModel)]="generalInfoDesc"
                type="text"
                class="form-control"
                id="description"
                name="description"
                maxlength="180"
                placeholder="The Acme Corporation is a fictional corporation that features prominently in the Road Runner/Wile E. Coyote animated shorts as a running gag featuring outlandish products that fail or backfire catastrophically at the worst possible times."
              ></textarea>
            </div>
          </div>
          <p class="textarea__counter">{{ generalInfoDesc.length }}/ 180</p>
        </form>
      </div>
    </div>
    <div class="col-sm">
      <div class="">
        <h3>{{ "Contact information" | translate }}</h3>
        <form>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="link"
                name="link"
                placeholder="www.acmecorp.com"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="organizationAddress"
                name="organizationAddress"
                placeholder="{{ 'Organization address' | translate }}"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="contactEmail"
                name="contactEmail"
                placeholder="{{ 'Contact email' | translate }}"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="{{ 'Phone number' | translate }}"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="w-100"></div>
    <div class="col-sm-6">
      <div class="">
        <h3>{{ "Social media links" | translate }}</h3>
        <form>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="facebookLink"
                name="facebookLink"
                placeholder="{{ 'Facebook' | translate }}"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="twitterLink"
                name="twitterLinkLink"
                placeholder="{{ 'Twitter' | translate }}"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="instagramLink"
                name="instagramLink"
                placeholder="{{ 'Instagram' | translate }}"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <input
                type="text"
                class="form-control"
                id="linkedInLink"
                name="linkedInLink"
                placeholder="{{ 'LinkedIn' | translate }}"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="footer__button">
    <button
      type="button"
      class="button button--purple button--big"
      [disabled]="false"
    >
      <span *ngIf="loader"
        ><span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        {{ "Saving" | translate }}</span
      ><span *ngIf="!loader">{{ "Save" | translate }}</span>
    </button>
  </div>
</div>
